import { Component, HostListener } from '@angular/core';
import { BaseComponent } from 'src/app/core';

@Component({
  selector: 'app-go-to-top',
  templateUrl: './go-to-top.component.html',
  styleUrls: ['./go-to-top.component.scss'],
  standalone: false,
})
export class GoToTopComponent extends BaseComponent {
  windowScrolled: boolean;
  constructor() {
    super();
  }
  @HostListener('window:scroll', [])
  onWindowScroll() {
    if (window.pageYOffset > 100 || document.documentElement.scrollTop > 100 || document.body.scrollTop > 100) {
      this.windowScrolled = true;
    } else if (
      (this.windowScrolled && window.pageYOffset) ||
      document.documentElement.scrollTop ||
      document.body.scrollTop < 10
    ) {
      this.windowScrolled = false;
    }
  }
  scrollToTop() {
    (function smoothscroll() {
      const currentScroll = document.documentElement.scrollTop || document.body.scrollTop;
      if (currentScroll > 0) {
        window.scroll({
          top: 0,
          behavior: 'smooth',
        });
      }
    })();
  }

  scrollToBottom() {
    const scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
    window.scroll({
      top: scrollHeight,
      behavior: 'smooth',
    });
  }
}
